import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom"
import { roles } from './utils/constants';
import { useLocation, useParams } from 'react-router'

function GuardedRoute(props) {
  const { Component } = props;
  const navigate = useNavigate()
  const {id} = useParams()
  const location = useLocation()
  if(id)
   {
    const match = location.pathname.match(/^(\/[^/]+\/[^/]+)/); // Matches the first two segments
    const basePath = match ? match[1] : location.pathname;
    if(basePath === '/home/slotbooking'){
      localStorage.setItem('slot-id', id)
    }
    else{
      localStorage.setItem('discount-obj', id)
    }
    }
  
  useEffect(() => {
    if (!localStorage.getItem("token") ) {
      localStorage.removeItem("token")
      localStorage.removeItem("role")
      localStorage.removeItem('salesTabFlag')
      localStorage.removeItem('type')
      localStorage.removeItem("main_user")
      localStorage.removeItem("sales_team")
      navigate("/")
    }
    const role = localStorage.getItem("role")
    if (role !== roles.salesperson && role !== roles.advertiser && role !== roles.ops && role !== roles.financer && role !== roles.network_ad_manager && role !== roles.b2b && role !== roles.legalperson && role !== roles.designer && role!== roles.content_writer) {
      localStorage.removeItem("token")
      localStorage.removeItem("role")
      localStorage.removeItem('salesTabFlag')
      localStorage.removeItem('type')
      localStorage.removeItem("main_user")
      localStorage.removeItem("sales_team")
      navigate("/")
    }

  })
  return (
    <>
    
    <Component />
    </>
  )
}

export default GuardedRoute;